// Clear Out theme — interactions
(function () {
  // Header scroll state
  var header = document.querySelector('.co-header');
  function onScroll() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Mobile menu
  var burger = document.querySelector('.co-burger');
  if (burger && header) {
    burger.addEventListener('click', function () {
      header.classList.toggle('is-open');
    });
    document.querySelectorAll('.co-mobile-menu a').forEach(function (a) {
      a.addEventListener('click', function () { header.classList.remove('is-open'); });
    });
  }

  // Reveal on scroll
  var reveals = document.querySelectorAll('.co-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Before/after comparison sliders
  document.querySelectorAll('.co-compare').forEach(function (card) {
    var range = card.querySelector('.co-compare__range');
    var wrap = card.querySelector('.co-compare__before-wrap');
    var beforeImg = card.querySelector('.co-compare__before-wrap img');
    var handle = card.querySelector('.co-compare__handle');
    if (!range || !wrap || !handle) return;
    function update(pos) {
      wrap.style.width = pos + '%';
      if (beforeImg) beforeImg.style.width = (10000 / Math.max(pos, 1)) + '%';
      handle.style.left = pos + '%';
    }
    range.addEventListener('input', function () { update(Number(range.value)); });
    update(Number(range.value || 50));
  });
})();
